import React from 'react';
import { motion } from 'framer-motion';

export default function Hero({ section }) {
  if (!section) return null;

  return (
    <section className="relative overflow-hidden bg-slate-950 min-h-[60vh] flex items-stretch">
      {/* Background Decorative Elements */}
      <div className="absolute top-0 left-0 -translate-y-1/2 -translate-x-1/4 w-[800px] h-[800px] bg-red-900/10 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-0 translate-y-1/2 translate-x-1/4 w-[600px] h-[600px] bg-green-900/10 rounded-full blur-3xl" />

      {/* Split Background */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute inset-0 bg-gray-800" />
        <div className="absolute inset-0 lg:left-1/2">
          {section.image?.[0] && (
            <img
              src={section.image[0]}
              alt="Flying dove in Palestinian colours holding an olive branch"
              className="absolute inset-0 w-full h-full object-cover opacity-40 lg:opacity-100"
            />
          )}
          <div className="absolute inset-0 bg-gradient-to-b from-gray-800/80 via-transparent to-gray-800/80 lg:bg-gradient-to-r lg:from-gray-800 lg:via-gray-900/40 lg:to-transparent" />
        </div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 min-h-[60vh]">
          <div className="flex items-center py-12 md:py-20">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, ease: "easeOut" }}
              className="max-w-xl w-full"
            >
              <div className="flex items-center gap-2.5 text-white text-xs font-bold uppercase tracking-widest mb-6">
                <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-white/10 text-red-500 shadow-sm">
                  <i className="fa-solid fa-dove text-xs" />
                </span>
                <span>Dansk Palæstinensisk Forening</span>
              </div>
              <h1 className="text-4xl md:text-6xl font-black text-white leading-[1.1] mb-6 tracking-tight uppercase">
                {section.title}
              </h1>
              <div 
                className="text-lg text-white mb-10 leading-relaxed"
                dangerouslySetInnerHTML={{ __html: section.content }}
              />
              <div className="flex flex-col sm:flex-row gap-4">
                <a
                  href="#membership"
                  className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold rounded-full text-white bg-red-600 hover:bg-red-700 transition-all duration-300 shadow-xl shadow-red-900/20 hover:-translate-y-1"
                >
                  Bliv medlem
                </a>
                <a
                  href="#contribution"
                  className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold rounded-full text-white bg-transparent border-2 border-white hover:border-white transition-all duration-300 hover:-translate-y-1"
                >
                  Giv et bidrag
                </a>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
